import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropZone", "fileName"]

  connect() {
    if (this.hasDropZoneTarget && this.hasInputTarget) {
      this.setupDragAndDrop()
    } else {
      console.warn('FileUploadController: Missing required targets (dropZone or input)')
    }
  }

  disconnect() {
    // Clean up event listeners on document.body
    const events = ['dragenter', 'dragover', 'dragleave', 'drop']
    events.forEach(eventName => {
      document.body.removeEventListener(eventName, this.preventDefaults.bind(this), false)
    })
  }

  setupDragAndDrop() {
    const dropZone = this.dropZoneTarget
    const input = this.inputTarget

    // Prevent default drag behaviors
    const events = ['dragenter', 'dragover', 'dragleave', 'drop']
    events.forEach(eventName => {
      dropZone.addEventListener(eventName, this.preventDefaults.bind(this), false)
      document.body.addEventListener(eventName, this.preventDefaults.bind(this), false)
    })

    // Highlight drop area when item is dragged over it
    const highlightEvents = ['dragenter', 'dragover']
    highlightEvents.forEach(eventName => {
      dropZone.addEventListener(eventName, this.highlight.bind(this), false)
    })

    const unhighlightEvents = ['dragleave', 'drop']
    unhighlightEvents.forEach(eventName => {
      dropZone.addEventListener(eventName, this.unhighlight.bind(this), false)
    })

    // Handle dropped files
    dropZone.addEventListener('drop', this.handleDrop.bind(this), false)

    // Handle file selection via click
    input.addEventListener('change', this.handleFileSelect.bind(this), false)
  }

  preventDefaults(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  highlight(e) {
    this.dropZoneTarget.classList.add('border-primary-500', 'bg-primary-50')
  }

  unhighlight(e) {
    this.dropZoneTarget.classList.remove('border-primary-500', 'bg-primary-50')
  }

  handleDrop(e) {
    const dt = e.dataTransfer
    const files = dt.files

    this.handleFiles(files)
  }

  handleFileSelect(e) {
    const files = e.target.files
    this.handleFiles(files)
  }

  handleFiles(files) {
    if (files.length > 0) {
      const file = files[0]
      
      // Check if it's a CSV file
      if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
        alert('Please select a CSV file')
        return
      }

      // Update the file input
      const dt = new DataTransfer()
      dt.items.add(file)
      this.inputTarget.files = dt.files

      // Update the display
      this.updateFileDisplay(file)
    }
  }

  updateFileDisplay(file) {
    // Find or create a file name display element
    const dropZone = this.dropZoneTarget
    let fileNameDisplay = dropZone.querySelector('.file-name-display')
    
    if (!fileNameDisplay) {
      fileNameDisplay = document.createElement('p')
      fileNameDisplay.className = 'file-name-display mt-2 text-sm text-neutral-600'
      dropZone.querySelector('.space-y-1').appendChild(fileNameDisplay)
    }

    fileNameDisplay.innerHTML = `
      <span class="font-medium">Selected:</span> ${file.name} 
      <span class="text-neutral-400">(${this.formatFileSize(file.size)})</span>
    `

    // Change the upload text
    const uploadText = dropZone.querySelector('label span')
    if (uploadText) {
      uploadText.textContent = 'Change file'
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
  }
}